import {PlainLanguages} from '@/enum';

export function getUntranslatedLanguages(translatedLanguages) {
  if (!translatedLanguages) return [];
  return Object.keys(PlainLanguages).filter(key =>
    !translatedLanguages.includes(key) &&
    !translatedLanguages.includes(PlainLanguages[key].name));
}
